import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ActionButton.module.css';

const VARIANT_CLASS = {
    neutral: 'neutral',
    danger: 'danger',
    gold: 'gold',
};

export default function ActionButton({
    variant = 'neutral',
    to,
    type = 'button',
    className,
    children,
    ...rest
}) {
    const classes = `${styles.action} ${styles[VARIANT_CLASS[variant] || VARIANT_CLASS.neutral]} ${className || ''}`;

    if (to) {
        return (
            <Link to={to} className={classes} {...rest}>
                {children}
            </Link>
        );
    }

    return (
        <button type={type} className={classes} {...rest}>
            {children}
        </button>
    );
}
